import { getSearchStats, setSearchStats, trackLegacySearchEvent, trackSubmitSearchEvent } from '@libs/analytics';

import type { AssistedSearchState } from '../search.types';

type TrackProps = {
    assistedSearch: AssistedSearchState;
    query: string;
    trackOptimizelySearch?: () => void;
};

export function trackApplicationSubmit({ assistedSearch, query, trackOptimizelySearch }: TrackProps) {
    const searchType = assistedSearch.isModified ? 'assisted' : 'manual';

    if (assistedSearch.isModified) {
        trackSubmitSearchEvent(
            assistedSearch.searchTerm,
            assistedSearch.searchAssistName,
            assistedSearch.searchAssistTerm
        );
    } else {
        trackSubmitSearchEvent(query);
    }

    trackOptimizelySearch?.();
    setSearchStats({ ...getSearchStats(), searchTerm: query, searchType });
    trackLegacySearchEvent(query, assistedSearch.searchAssistName);
}
